import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "relative flex flex-col items-start gap-0.5 pb-0.5 w-full text-left text-(length:--size-m) font-inter text-(--text-text-black-default) dark:text-(--colors-text-white-default)" };
const _hoisted_2 = ["id"];
const _hoisted_3 = ["aria-labelledby"];
import { useId } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'UserReadonlyChipsField',
    props: {
        label: {}
    },
    setup(__props) {
        const labelId = useId();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("span", {
                    id: _unref(labelId),
                    class: "leading-(--line-height-l) font-(--weight-medium)"
                }, _toDisplayString(__props.label), 9 /* TEXT, PROPS */, _hoisted_2),
                _createElementVNode("div", {
                    role: "group",
                    "aria-labelledby": _unref(labelId),
                    class: "flex flex-wrap items-center gap-1 w-full min-h-9 px-2 py-1.5 rounded-xl border border-solid border-(--border-border-base-soft) dark:border-(--border-border-base) bg-(--background-background-white-secondary-soft) dark:bg-(--colors-background-disabled) shadow-xs"
                }, [
                    _renderSlot(_ctx.$slots, "default")
                ], 8 /* PROPS */, _hoisted_3)
            ]));
        };
    }
});
